import { DialogComponent } from '@theme/dialog';

class TileCalculatorComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    this.init();
  }

  init() {
    this.wallRows = this.querySelectorAll('[data-area-type="wall"]');
    this.floorRows = this.querySelectorAll('[data-area-type="floor"]');
    this.wallToggle = this.querySelector('[ref="wallToggle"]');
    this.floorToggle = this.querySelector('[ref="floorToggle"]');
    this.wallRowsContainer = this.querySelector('[ref="wallRowsContainer"]');
    this.floorRowsContainer = this.querySelector('[ref="floorRowsContainer"]');

    this.wallSubtotalEl = this.querySelector('[ref="wallSubtotal"]');
    this.floorSubtotalEl = this.querySelector('[ref="floorSubtotal"]');
    this.totalAreaEl = this.querySelector('[ref="totalArea"]');
    this.totalPriceEl = this.querySelector('[ref="totalPrice"]');
    this.packagePriceEl = this.querySelector('[ref="packagePrice"]');
    this.packageInfoEl = this.querySelector('[ref="packageInfo"]');

    this.wastageInput = this.querySelector('[ref="wastageInput"]');
    this.applyButton = this.querySelector('[ref="applyButton"]');

    // 🔥 DATA VAN SHOPIFY
    this.pricePerM2 = parseFloat(this.dataset.price || '0') / 100;
    this.variantPrice = parseFloat(this.dataset.variantPrice || '0') / 100;
    this.variantId = this.dataset.variantId;

    this.salesUnit = this.dataset.salesUnit || 'box'; // box of piece
    this.unitLabel = this.dataset.unitLabel || (this.salesUnit === 'piece' ? 'tegel' : 'verpakking');
    this.m2PerUnit = parseFloat(this.dataset.m2PerUnit || '0');

    // fallback berekening
    if (!this.m2PerUnit || this.m2PerUnit <= 0) {
      this.m2PerUnit = this.pricePerM2 > 0 ? this.variantPrice / this.pricePerM2 : 0;
    }

    // cm → meter
    this.conversionFactor = 0.01;

    this.attachEvents();
    this.calculate();
  }

  attachEvents() {
    this.wallToggle?.addEventListener('change', () => this.calculate());
    this.floorToggle?.addEventListener('change', () => this.calculate());

    this.wallRows.forEach(row => {
      row.querySelectorAll('input').forEach(input => {
        input.addEventListener('input', () => this.calculate());
      });
    });

    this.floorRows.forEach(row => {
      row.querySelectorAll('input').forEach(input => {
        input.addEventListener('input', () => this.calculate());
      });
    });

    this.wastageInput?.addEventListener('input', () => this.calculate());
    this.applyButton?.addEventListener('click', () => this.apply());
  }

  formatMoney(value) {
    return value.toLocaleString('nl-NL', {
      style: 'currency',
      currency: 'EUR'
    });
  }

  formatM2(value) {
    return `${value.toFixed(2)} m²`;
  }

  getUnitLabel(count) {
    if (count === 1) return this.unitLabel;
    return this.unitLabel === 'tegel' ? 'tegels' : 'verpakkingen';
  }

  calculateRow(row) {
    const w = parseFloat(row.querySelector('[data-type="width"]')?.value || 0);
    const h = parseFloat(row.querySelector('[data-type="height"]')?.value || 0);

    const area = (w * this.conversionFactor) * (h * this.conversionFactor);

    const display = row.querySelector('.row-area');
    if (display) display.textContent = this.formatM2(area);

    return area;
  }

  calculate() {
    let wall = 0;
    let floor = 0;

    if (this.wallToggle?.checked) {
      this.wallRows.forEach(r => wall += this.calculateRow(r));
    }

    if (this.floorToggle?.checked) {
      this.floorRows.forEach(r => floor += this.calculateRow(r));
    }

    const total = wall + floor;
    const wastage = parseFloat(this.wastageInput?.value || 0);

    const required = total * (1 + wastage / 100);

    const units = Math.ceil(required / this.m2PerUnit);
    const delivered = units * this.m2PerUnit;

    const unitPrice = this.variantPrice || (this.pricePerM2 * this.m2PerUnit);
    const totalPrice = units * unitPrice;

    // UI
    this.totalAreaEl.textContent = this.formatM2(required);
    this.totalPriceEl.textContent = this.formatMoney(totalPrice);
    this.packagePriceEl.textContent = this.formatMoney(unitPrice);
    this.packageInfoEl.textContent = `${units} ${this.getUnitLabel(units)} · ${this.formatM2(delivered)}`;

    this.units = units;
    this.required = required;
    this.delivered = delivered;
  }

  apply() {
    if (!this.units || !this.variantId) return;

    const formData = new FormData();
    formData.append('id', this.variantId);
    formData.append('quantity', this.units);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(r => r.json())
    .then(() => {
      document.dispatchEvent(new CustomEvent('cart:update'));
    });

    this.closeDialog();
  }
}

if (!customElements.get('tile-calculator-component')) {
  customElements.define('tile-calculator-component', TileCalculatorComponent);
}